import { GridRowId } from '@mui/x-data-grid-pro'
import { FormikErrors } from 'formik'
import { bulkActionErrors } from '../../constants'
import { BulkReassignDTO } from '../../typings/BulkReassign'
import { BulkReassignFormModel } from './typings'

export function validate(
  model: BulkReassignFormModel,
): FormikErrors<BulkReassignFormModel> {
  const errors: FormikErrors<BulkReassignFormModel> = {}

  if (model.salesTeamId === '') errors.salesTeamId = 'Required'
  if (model.assigneeId === '') errors.assigneeId = 'Required'

  return errors
}

export function setError(
  errors: Map<GridRowId, string[]>,
  id: number,
  errDescription: string,
) {
  const rowError = errors.get(id)
  errors.set(id, rowError ? [...rowError, errDescription] : [errDescription])
}

export function formatErrors(dto?: BulkReassignDTO, removeServices?: boolean) {
  const errors = new Map<GridRowId, string[]>()

  if (!!dto) {
    const {
      alreadyClosedEntities = [],
      wrongBranchEntities = [],
      serviceAssociatedEntities = [],
      locationMatchedEntities = [],
      crossBranchReassignEnabled,
      openEntities = [],
    } = dto

    if (crossBranchReassignEnabled) {
      alreadyClosedEntities?.forEach((e) => {
        setError(errors, e.entityId, bulkActionErrors.reassign.closed.rowError)
      })

      if (!removeServices) {
        serviceAssociatedEntities?.forEach((e) => {
          setError(errors, +e, bulkActionErrors.reassign.services.rowError)
        })
      }

      locationMatchedEntities?.forEach((e) => {
        setError(errors, +e, bulkActionErrors.reassign.matched.rowError)
      })
    } else {
      wrongBranchEntities?.forEach((e) => {
        errors.set(e.entityId, [bulkActionErrors.reassign.branch.rowError])
      })
    }

    openEntities?.forEach((e) => {
      setError(errors, e.entityId, bulkActionErrors.reassign.open.rowError)
    })

    const locationMatchedSet = new Set(locationMatchedEntities)
    const alreadyClosedSet = new Set(
      alreadyClosedEntities?.map((x) => x.entityId),
    )

    return {
      errors,
      hasAlreadyClosed:
        alreadyClosedEntities && alreadyClosedEntities.length > 0
          ? true
          : false,
      hasWrongBranch: crossBranchReassignEnabled
        ? false
        : wrongBranchEntities && wrongBranchEntities.length > 0
        ? true
        : false,
      hasServices: crossBranchReassignEnabled
        ? serviceAssociatedEntities && serviceAssociatedEntities.length > 0
          ? true
          : false
        : false,
      hasLocationMatches: crossBranchReassignEnabled
        ? locationMatchedEntities && locationMatchedEntities.length > 0
          ? true
          : false
        : false,
      hasServicesCount: serviceAssociatedEntities
        ? serviceAssociatedEntities.filter(
            (s) => !locationMatchedSet.has(s) && !alreadyClosedSet.has(+s),
          )?.length
        : 0,
      hasOpen: openEntities && openEntities.length > 0 ? true : false,
    }
  }

  return {
    errors,
    hasAlreadyClosed: false,
    hasWrongBranch: false,
    hasServices: false,
    hasLocationMatches: false,
    hasOpen: false,
  }
}
